<template>
  <v-row justify="center">
    <v-dialog v-model="showTable" persistent scrollable max-width="60%">
      <v-card>
        <v-card-title class="pt-0">
          <v-row>
            <v-col class="text-end px-0 py-0" cols="12">
              <v-btn icon dark @click="close()">
                <v-icon color="primary">mdi-close</v-icon>
              </v-btn>
            </v-col>
            <v-col class="text-center py-0" cols="12">
              <h1 class="mb-0 mt-0" style="font-size:22px;">Dados de Entrega</h1>
              <p v-if="formData.id == null" style="font-size:14px;">Informe o dados de entrega para a operadora.</p>
            </v-col>
          </v-row>
        </v-card-title>

        <v-card-text class="py-0">
<!-- 
          <v-row class="ma-0">
            <v-col class="px-1" cols="12" sm="4" md="3">
              <h2 class="texts">Envio:</h2>
              <p class="texts mb-0">
                  {{ formData.dt_envio | formatDate }}
              </p>
            </v-col>
            <v-col class="px-1" cols="12" sm="4" md="3">
              <h2 class="texts">Empresa:</h2>
              <p class="texts">
                  {{formData.empresa}}
              </p>
            </v-col>
            <v-col class="px-1" cols="12" sm="4" md="3">
              <h2 class="texts">Código de rastreio:</h2>
              <p class="texts">
                  {{formData.codigo_rastreio}}
              </p>
            </v-col>
            <v-col class="px-1" cols="12" sm="4" md="3">
              <h2 class="texts">Observações:</h2>
              <p class="texts">
                  {{formData.observacao}}
              </p>
            </v-col>
          </v-row> -->

          <!-- <v-row>
            <v-col class="card-form" cols="12"> -->
              <v-form ref="dadosEntregaForm" :value="formValid">
                <v-row class="py-0">
                  <v-col class="py-0 px-2" cols="6">
                    <label>Data de emissão</label>
                    <p v-if="!edition" class="texts mb-0">
                      {{ formData.dt_envio | formatDate }}
                    </p>
                    <v-menu
                      v-if="edition"
                      ref="dtI"
                      v-model="dtI"
                      :close-on-content-click="true"
                      transition="scale-transition"
                      offset-y
                    >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="dt_envio"
                        dense
                        v-mask="'##/##/####'"
                        format="DD/MM/YYYY"
                        placeholder="DD/MM/AAAA"
                        label
                        outlined
                        v-bind="attrs"
                        v-on="on"
                        append-icon="mdi-calendar-blank"
                        @blur="date = parseDate(dt_envio)"
                        :rules="[formRules.requiredField, formRules.typeDateFormated]"
                      ></v-text-field>
                    </template>
                    <v-date-picker color="primary"  v-model="date" no-title scrollable></v-date-picker>
                  </v-menu>
                  </v-col>
                  <v-col class="py-0 px-2" cols="6">
                    <label>Empresa</label>
                    <p v-if="!edition" class="texts">
                      {{formData.empresa}}
                    </p>
                    <v-text-field
                      v-if="edition"
                      v-model="formData.empresa"
                      placeholder="Nome da empresa"
                      single-line
                      outlined
                      dense
                      :rules="formRules.required"
                    ></v-text-field>
                  </v-col>
                  <v-col class="py-0 px-2" cols="6">
                    <label>Código de Rastreio</label>
                    <p v-if="!edition" class="texts">
                      {{formData.codigo_rastreio}}
                    </p>
                    <v-text-field
                      v-if="edition"
                      v-model="formData.codigo_rastreio"
                      placeholder="Ex.: 123434"
                      single-line
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col class="py-0 px-2" cols="6">
                    <label>Observações</label>
                    <p v-if="!edition" class="texts">
                      {{formData.observacao}}
                    </p>
                    <v-text-field
                      v-if="edition"
                      v-model="formData.observacao"
                      placeholder="Opcional"
                      single-line
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col class="py-0 px-2" cols="12">
                    <label v-if="edition">Anexo</label>
                    <v-file-input
                      v-if="edition"
                      :placeholder="formData.anexo == null ? 'Selecione o arquivo dos dados de entrega' : formData.anexo"
                      outlined
                      v-model="file"
                      single-line
                      dense
                      :prepend-icon="null"
                      append-icon="fa-upload"
                    ></v-file-input>
                    <v-btn v-if="dadosEntregaData.doc_id!=null && !edition"
                      @click="getDocument({doc_id: dadosEntregaData.doc_id, nome: dadosEntregaData.anexo})"
                      color="primary" 
                      class="py-1 px-0 mt-0" 
                      x-small 
                      text>
                      <v-icon class="py-0 pl-0 pr-1" x-small>fa-download</v-icon>
                      {{dadosEntregaData.anexo}}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
            <!-- </v-col>
          </v-row> -->
        </v-card-text>
        <v-card-actions class="px-5 pb-5 pt-0">
            <v-btn
              v-if="edition && formData.id != null"
              max-width="100%"
              height="30px"
              small
              color="primary"
              depressed
              class="px-5"
              outlined
              @click="edition = false"
            >
              Cancelar
            </v-btn>
            <v-btn
              v-if="formData.id == null"
              max-width="100%"
              height="30px"
              small
              color="primary"
              depressed
              class="px-5"
              outlined
              @click="close()"
            >
              Cancelar
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              v-if="edition"
              color="primary"
              max-width="100%"
              height="30px"
              small
              depressed
              class="px-5"
              @click="validate()"
            >
              Salvar
            </v-btn>
            <v-btn
              v-show="!edition && !showEdit"
              v-if="userData.PermissaoAcoes.faturamento.includes('updatedadosentrega')"
              outlined
              height="30px"
              small
              color="primary"
              depressed
              class="float-right px-4"
              @click="edition = true"
            >Editar</v-btn>
            <v-tooltip v-else center bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                outlined
                color="rgb(151 151 151 / 58%)"
                height="30px"
                small
                class="float-right px-4"
                depressed
                v-bind="attrs"
                v-on="on"
                >Editar</v-btn>
              </template>
              <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF;">
                Você não possui permissão para executar esta ação.
              </span>
            </v-tooltip>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import moment from "moment";
moment.locale("pt-BR");
import { mapState } from "vuex";
export default {
  data() {
    return {
      formData: {
            id: null,
            anexo: null,
            empresa: null,
            dt_envio: null,
            codigo_rastreio: null,
            observacao: null
        },
      file: null,
      showTable: false,
      dtI: false,
      dt_envio: null,
      date: null,
      formValid: true,
      edition: true,
      showEdit: false,
    }
  },
  filters: {
    formatDate(date) {
      return moment(date).format("L");
    },
  },
  methods: {
    addFile(file) {
      this.file = file
    },
    close() {
      this.showClose(false)
      this.$refs.dadosEntregaForm.reset()
      // this.file = null
      // this.formData.anexo = null
      // if (this.formData.id == 0) {
      //     this.formData = {
      //       id: "",
      //       empresa: "",
      //       dt_envio: "",
      //       codigo_rastreio: "",
      //       observacao: ""
      //   }
      //   this.dt_envio = ""
      //   this.file = null
      // }
    },
    formatDate (date) {
        if (!date) return null
        const [year, month, day] = date.split('T')[0].split('-')
        return `${day}/${month}/${year}`
    },
    parseDate (date) {
        if (!date) return null
        const [day, month, year] = date.split('/')
        return `${year}-${month}-${day}`
    },
    validate(){
      if(this.$refs.dadosEntregaForm.validate()){
           this.sendForm(this.formData, this.file)
      }
    },
  },
  computed: {
    ...mapState({
      grupoEconomico: (state) => state.permissions.grupoEconomico,
      formRules: (state) => state.formRules,
    }),
  },
  watch: {
    showOpen(val) {
      this.showTable = val
      if(val && this.dadosEntregaData.id != null){
        this.formData = this.dadosEntregaData? Object.assign({}, { ...this.dadosEntregaData }): this.formData
        this.dt_envio = this.formatDate( this.dadosEntregaData.dt_envio);
        this.date = this.formData.dt_envio
        this.edition = false
      } else {
        // this.$refs.dadosEntregaForm.reset()
        // this.file = null
        // this.formData.anexo = null
        // this.$refs.dadosEntregaForm.resetValidation()
      }
   },
   date(val) { 
      this.dt_envio = this.formatDate(val);
    },
    dt_envio(val) {
      this.formData.dt_envio = this.parseDate(val);
    },
    file(){
      this.formData.doc_id = null;
    },
    parameter(param) {
      if (!!param.config && param.config.FAT_DADOS_ENTREGA_OBRIGATORIO && param.status!='F') 
        this.showEdit = true
    }
  },
  props: {
    dadosEntregaData: Object,
    showOpen: Boolean,
    showClose: Function,
    sendForm: Function,
    getDocument: Function,
    userData: Object,
    parameter: Object
  }
}
</script>